<script lang="ts" setup>
/**
 * The component is required to support the implementation of the "add to wishlist" button feature in the B2C Twig/Vue context.
 * It could be moved to the ProductCard (similar to the TrashButton) after migration.
 */
import HeartButton from '@satch-ui/components/button/HeartButton.vue'
import { useWishlistItem } from '@storefront-satch/composables/wishlist'

import { vTracking } from '@fond-of/analytics'
import { vE2eTestId } from '@fond-of/telemetry'

const props = defineProps<{
  productId: string
  pdp?: boolean
}>()

const { isItemActive, toggleWishlistItem } = useWishlistItem(props.productId)
</script>

<template>
  <HeartButton
    :id="props.pdp ? 'addToWishlistBtn' : null"
    v-tracking="'cs-popin-add-to-wishlist-layer'"
    v-e2e-test-id="'addToWishlistButton'"
    :class="[
      'pb-3 pl-0 pr-3 pt-0',
      {
        'flex !items-start !justify-start': !props.pdp,
      },
    ]"
    :data-sku="props.productId"
    :is-active="isItemActive"
    :pdp="props.pdp"
    @click.stop="toggleWishlistItem()"
  />
</template>
